import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoes.vue?vue&type=template&id=07f3496a&scoped=true"
import script from "./LicitacaoAtualizacaoAcoes.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoes.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoAtualizacaoAcoes.vue?vue&type=style&index=0&id=07f3496a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3496a",
  null
  
)

export default component.exports